import React, { useMemo } from "react";
import styles from "./WelcomeBanner.module.css";

const NUMBER_OF_STRIPS = 24;

const getRandomItem = (array) => array[Math.floor(Math.random() * array.length)];

export default function WelcomeBanner({ userName, badgeText, subtitles, helperTexts, images, logoSrc }) {
  const subtitle = useMemo(() => getRandomItem(subtitles), [subtitles]);
  const helperText = useMemo(() => getRandomItem(helperTexts), [helperTexts]);
  const background = useMemo(() => getRandomItem(images), [images]);

  return (
    <section className={styles.banner} style={{ backgroundImage: `url("${background}")` }}>
      <div className={styles.overlay} />

      <div className={styles.dots}>
        {Array.from({ length: NUMBER_OF_STRIPS }).map((_, index) => (
          <div
            key={index}
            className={styles.dotsStrip}
            style={{ "--index": index, "--delay": `${index * -0.1}s` }}
          />
        ))}
      </div>

      <div className={styles.content}>
        <div>
          <h1 className={styles.title}>
            <strong>Bem-vindo(a) à Fastfrete,</strong> {userName}!
          </h1>
          <p className={styles.subtitle}>{subtitle}</p>
        </div>

        <footer className={styles.footer}>
          <div className={styles.footerLeft}>
            <div className={styles.helper}>{helperText}</div>

            {badgeText && <div className={styles.badge}>{badgeText}</div>}
          </div>

          <div className={styles.logo}>
            <img src={logoSrc} alt="FastFrete" className={styles.logoImage} />
            <div className={styles.logoCompany}>
              Uma empresa do grupo{" "}
              <strong>
                <span className={styles.logoCompanyFts}>fts</span>
                <span className={styles.logoCompanyPar}>par.</span>
              </strong>
            </div>
          </div>
        </footer>
      </div>
    </section>
  );
}
